import { colours, device } from "@helpers";
import React from "react";
import styled from "styled-components";

const Quote = styled.p`
  font-family: var(--euclid-medium) !important;
  margin-bottom: 24px !important;
  align-self: center;
`;

const QuoteName = styled.p`
  a {
    text-decoration: none;
    font-weight: bold;
  }
`;

const Div = styled.div`
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${device.laptopM}) {
    text-align: center;
    margin-bottom: 10px;
  }
`;

const Stars = styled.span`
  color: ${colours.LIGHT_GREY};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  font-size: 24px;
`;

const TestimonialItem = ({
	displayStars,
	quote,
	quoteAuthor,
	linkToReview,
	reviewSource,
	reviewSourceLink,
	reviewSourceText,
	ariaHidden,
}: {
	displayStars: string;
	quote: string;
	quoteAuthor: string;
	quoteSource: string;
	linkToReview: string;
	reviewSource: string;
	reviewSourceLink: string;
	reviewSourceText: string;
	ariaHidden: string;
}) => {
	const tabIndex = ariaHidden === "true" ? -1 : 0;

	const renderQuote = () =>
		quote && <Quote className="quote">{`"${quote}"`}</Quote>;

	const renderQuoteName = () =>
		quoteAuthor && (
			<QuoteName>
				<span>
					Says{" "}
					<a
						href={linkToReview}
						target="_blank"
						rel="noreferrer"
						tabIndex={tabIndex}
					>
						{`${quoteAuthor}`}
					</a>
					{reviewSourceText && ` ${reviewSourceText} `}
					<a
						href={reviewSourceLink}
						target="_blank"
						rel="noreferrer"
						tabIndex={tabIndex}
					>
						{reviewSource}
					</a>
				</span>
			</QuoteName>
		);

	return (
		<>
			{renderQuote()}
			{(displayStars as string) === "Yes" && <span aria-label="5 out of 5 stars"><Stars aria-hidden="true">★ ★ ★ ★ ★</Stars></span>}
			<Div>{renderQuoteName()}</Div>
		</>
	);
};

export default TestimonialItem;
